import axios from "axios";
import { getContext } from "../utils/sessionStorage";

interface apiConsumerInterface {
  endpoint: string;
  method: "GET" | "POST" | "DELETE" | "PUT" | "PATCH";
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  body?: any;
  headers?: Record<string, string>;
}

export const apiConsumer = ({
  endpoint,
  method,
  body,
  headers,
}: apiConsumerInterface) => {
  const context = getContext();
  const token = context?.user?.token;
  return axios({
    baseURL: `${process.env.REACT_APP_API_URL}`,
    url: endpoint,
    method,
    data: body,
    headers: {
      ...headers,
      ...(token && { Authorization: `Bearer ${token}` }),
      [`${process.env.REACT_APP_HEADER1}`]: "web",
      [`${process.env.REACT_APP_HEADER2}`]: "yoshi-dashboard",
      [`${process.env.REACT_APP_HEADER3}`]: `1`,
    },
  });
};
